import { addDoc, collection, doc, getDoc, getDocs, orderBy, query, setDoc, where } from "firebase/firestore";
import { auth, firestoreDb } from "../../firebase/utils";

export const handleAddMessage = async(msg)=> {
        return new Promise((resolve,reject) => {
                addDoc(collection(firestoreDb,'conversations'),{
                    ...msg,
                    isView:false,
                    createdAt:new Date()
                })
                .then(() => {
                    resolve({
                        ...msg,
                    isView:false,
                    createdAt:new Date()
                    })
                })
                .catch((err) => {
                    reject(err);
                })  
        })
    
    return;
}

export const handleGetMessages = async(user) => {
    return new Promise((resolve, reject) => {
        let chatsRef = collection(firestoreDb,'conversations');
        chatsRef = query(chatsRef, where('user_name_1','in',[user.userName_1,user.userName_2]), orderBy('createdAt','asc'));
        getDocs(chatsRef)
        .then((snapshot) => {
            
            let chatsArray = [];
            
            chatsArray = snapshot.docs.map(doc => {
                if(doc.exists) {
                    if((doc.data().user_name_1 == user.userName_1 && doc.data().user_name_2 == user.userName_2) || (doc.data().user_name_1 == user.userName_2 && doc.data().user_name_2 == user.userName_1))
                    {
                        return {
                            ...doc.data()
                        }
                    }
                }
                        
            });
            resolve(chatsArray);
        })
        .catch((err) => {
            reject(err);
        })
    })
}